/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardsClaimClaimRewardRequest
 */
export interface RewardsClaimClaimRewardRequest {
    /**
     * 
     * @type {number}
     * @memberof RewardsClaimClaimRewardRequest
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardsClaimClaimRewardRequest
     */
    rewardId?: number;
}

/**
 * Check if a given object implements the RewardsClaimClaimRewardRequest interface.
 */
export function instanceOfRewardsClaimClaimRewardRequest(value: object): value is RewardsClaimClaimRewardRequest {
    return true;
}

export function RewardsClaimClaimRewardRequestFromJSON(json: any): RewardsClaimClaimRewardRequest {
    return RewardsClaimClaimRewardRequestFromJSONTyped(json, false);
}

export function RewardsClaimClaimRewardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardsClaimClaimRewardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'rewardId': json['rewardId'] == null ? undefined : json['rewardId'],
    };
}

export function RewardsClaimClaimRewardRequestToJSON(json: any): RewardsClaimClaimRewardRequest {
    return RewardsClaimClaimRewardRequestToJSONTyped(json, false);
}

export function RewardsClaimClaimRewardRequestToJSONTyped(value?: RewardsClaimClaimRewardRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'rewardId': value['rewardId'],
    };
}

